<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-datetime ttLabel="reg_datetime" [ttModel]="menu.reg_datetime" ttReadonly></tt-datetime>
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="menu.reg_by_portal_user_name" ttReadonly></tt-input>
        <tt-textarea ttLabel="note" [ttModel]="menu.note" ttReadonly></tt-textarea>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-datetime class="col-xs-12 sp-0" tt-label="reg_datetime" tt-model="vm.model.menu.reg_datetime" tt-change="vm.model.menu.reg_datetime = $value" tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: true, disabled: false, align: 'right'}, minute: {show: true, disabled: false, align: 'right', interval: 1}}" tt-readonly="true"></tt-datetime>
        <tt-input class="col-xs-12 sp-0" tt-label="reg_by_portal_user_name" tt-model="vm.model.menu.reg_by_portal_user_name" tt-change="vm.model.menu.reg_by_portal_user_name = $value" tt-readonly="true"></tt-input>
        <tt-textarea class="col-xs-12 sp-0" tt-label="note" tt-model="vm.model.menu.note" tt-change="vm.model.menu.note = $value" tt-readonly="true"></tt-textarea>
    </tt-card>
</tt-page>-->
